import axios from './_nestAxios'

export const getAsSelect = (tipo, otrosFiltros, flagPorSede) =>
  axios.get('/tablas-personalizadas', {
    params: { tipo, tipoConsulta: 'select', filtros: otrosFiltros, nivelConsulta: flagPorSede ? 'sede' : '' }
  })

export const getAsSoloLectura = (tipo, flagPorSede) =>
  axios.get('/tablas-personalizadas', {
    params: { tipo, tipoConsulta: 'solo-lectura', nivelConsulta: flagPorSede ? 'sede' : '' }
  })

export const obtenerEstructuraPrecios = () => axios.get('/tablas-personalizadas/estructura-precios')

export const getAsEdicion = id => axios.get(`/tablas-personalizadas/${id}`)

export const nuevo = data => axios.post('/tablas-personalizadas', data)

export const actualizarxId = (id, data) => axios.put(`/tablas-personalizadas/${id}`, data)

export const eliminarxId = id => axios.delete(`/tablas-personalizadas/${id}`)
